// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DA0q","index":"styles_index__-EnLb"};